import { c as _c } from "react/compiler-runtime";
import { displayPercentageDiscount } from "@website/accommodation-ui/helpers/calculatePercentageDiscount";
import { InfoChips } from "@website/ui/info-chips";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import { SnappProDiscountChip } from "@website/website-ui/snapp-pro-discount-chip";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import { FC } from "react";
import { HotelCardPricingPropertiesType } from "./hotel-card-pricing.types";
export const HotelCardPricing: FC<HotelCardPricingPropertiesType> = properties => {
  const $ = _c(36);
  const router = useCompatRouter();
  const {
    date_from,
    date_to
  } = router.query;
  const {
    price,
    priceOff: t0,
    size: t1,
    discountPercentage,
    landing: t2,
    className,
    basePrice,
    basePriceOff,
    hasSnappProDiscount
  } = properties;
  const priceOff = t0 === undefined ? 0 : t0;
  const size = t1 === undefined ? "responsive" : t1;
  const landing = t2 === undefined ? false : t2;
  const hasDateAndPassengers = Boolean(date_from && date_to && router?.query?.room_capacity && Number(router?.query?.room_capacity) > 0);
  const isVilla = process.env.NEXT_PUBLIC_APP_NAME === "villa";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["website", "homepage"];
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const isHomePage = t3.includes(process.env.NEXT_PUBLIC_APP_NAME as string);
  const shouldShowDiscount = priceOff > 0 && price > priceOff && (size !== "small" || size === "small" && isHomePage);
  let t4;
  if ($[1] !== discountPercentage || $[2] !== landing || $[3] !== price || $[4] !== priceOff) {
    t4 = landing ? `%${numberConvert((Math.ceil(discountPercentage as number) * 100)?.toFixed(0), {
      locale: "fa"
    })}` : displayPercentageDiscount(price, priceOff);
    $[1] = discountPercentage;
    $[2] = landing;
    $[3] = price;
    $[4] = priceOff;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const discountText = t4;
  const discountedPrice = priceOff && price > priceOff ? priceOff : price;
  const effectivePrice = isVilla ? hasDateAndPassengers ? discountedPrice : basePriceOff ?? discountedPrice : discountedPrice;
  const villaOriginalPrice = hasDateAndPassengers ? price : basePrice;
  const villaDiscountedPrice = hasDateAndPassengers ? priceOff : basePriceOff;
  const shouldShowVillaDiscount = isVilla && size === "small" && typeof villaOriginalPrice === "number" && typeof villaDiscountedPrice === "number" && villaOriginalPrice > villaDiscountedPrice;
  const t5 = `${size === "small" ? "flex flex-col items-end justify-center" : `flex flex-col justify-end lg:justify-center ${size === "xSmall" ? "items-start gap-0" : "items-end lg:items-center"} `} `;
  let t6;
  if ($[6] !== discountPercentage || $[7] !== hasSnappProDiscount || $[8] !== landing || $[9] !== price || $[10] !== priceOff || $[11] !== router.locale || $[12] !== shouldShowDiscount || $[13] !== size) {
    t6 = shouldShowDiscount && !isVilla && <div className={`flex w-full items-center ${size === "xSmall" ? "gap-1" : "justify-end gap-2"}`}><span className={`text-on-surface-disable line-through ${size === "xSmall" ? "text-overline" : "text-body-2"}`}>{numberConvert(numberSeparator(price), {
          locale: router.locale || "fa"
        })}</span>{hasSnappProDiscount ? <SnappProDiscountChip percentage={discountPercentage as number} /> : <InfoChips className="!w-[32px] justify-center !p-[2px]" size={size === "xSmall" ? "compact" : "medium"} text={landing ? `%${numberConvert((Math.ceil(discountPercentage as number) * 100)?.toFixed(0), {
        locale: router.locale || "fa"
      })}` : displayPercentageDiscount(price, priceOff)} variant="round-accent" />}</div>;
    $[6] = discountPercentage;
    $[7] = hasSnappProDiscount;
    $[8] = landing;
    $[9] = price;
    $[10] = priceOff;
    $[11] = router.locale;
    $[12] = shouldShowDiscount;
    $[13] = size;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== discountPercentage || $[16] !== discountText || $[17] !== hasSnappProDiscount || $[18] !== router.locale || $[19] !== shouldShowVillaDiscount || $[20] !== villaOriginalPrice) {
    t7 = shouldShowVillaDiscount && <div className="flex w-full items-center justify-end gap-2"><span className="text-on-surface-disable text-body-2 line-through">{numberConvert(numberSeparator(villaOriginalPrice), {
          locale: router.locale || "fa"
        })}</span>{hasSnappProDiscount ? <SnappProDiscountChip percentage={discountPercentage as number} /> : <InfoChips className="!w-[30px] justify-center !p-[2px]" size="medium" variant="round-accent" text={discountText} />}</div>;
    $[15] = discountPercentage;
    $[16] = discountText;
    $[17] = hasSnappProDiscount;
    $[18] = router.locale;
    $[19] = shouldShowVillaDiscount;
    $[20] = villaOriginalPrice;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const t8 = `${className} ${size === "xSmall" ? "text-body-2 w-full font-bold" : size === "small" ? "text-on-surface-high-emphasis text-subtitle-1 font-bold" : "text-on-surface-high-emphasis text-headline-6 font-bold"}`;
  let t9;
  if ($[22] !== basePrice || $[23] !== effectivePrice || $[24] !== price || $[25] !== router.locale || $[26] !== size) {
    t9 = price ? size === "small" && basePrice && !isVilla ? <div className="flex flex-col items-end gap-1"><div>{numberConvert(numberSeparator(effectivePrice), {
          locale: router.locale || "fa"
        })}<span className="text-subtitle-2 px-1">تومان</span></div></div> : <>{numberConvert(numberSeparator(effectivePrice), {
        locale: router.locale || "fa"
      })}<span className={`px-1 ${size === "xSmall" ? "text-body-2" : "text-subtitle-2"}`}>تومان</span></> : <>ناموجود</>;
    $[22] = basePrice;
    $[23] = effectivePrice;
    $[24] = price;
    $[25] = router.locale;
    $[26] = size;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t8 || $[29] !== t9) {
    t10 = <span className={t8} itemProp="priceRange">{t9}</span>;
    $[28] = t8;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t10 || $[32] !== t5 || $[33] !== t6 || $[34] !== t7) {
    t11 = <div className={t5}>{t6}{t7}{t10}</div>;
    $[31] = t10;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  return t11;
};